/**
 * Directiva utilizada para ver y añadir inspecciones a las incidencias
 */
CampoExtraNumberDirectiva.$inject = [];
export default function CampoExtraNumberDirectiva() {
    return {
        restrict: 'AE',
        scope: {
            'campoExtra': '=',
            'updateActive': '=',
            'cargando': '=',
            'claseRow': '@'
        },
        template: require('./campos-extra-number.html'),
        controller: 'CamposExtraNumberCtrl as campExtNum',
        bindToController: true
    }
}